import React, { useEffect, useState } from 'react'
import { Button, Input, Layout, notification, PageHeader, Switch, Tooltip } from 'antd'
import idx from 'idx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { fetchPageById, invalidateCFCache, newSuiteCardModule, resetUpdatePageStatus, updatePage } from '~actions'
import { PageBasicInfo, ResultModal } from '~components'
import { getCurrentUser } from '~context'
import { Spinner } from '~stories'
import { getFileName } from '~utils'
import { validatePage } from '~validators'

import { createEmptyUniversalModule } from '../../components/UniversalTemplateModules/universalTemplateDefaults'
import { MSG_CF, PAGE_TYPES, PAGE_TYPES_PREMIUM_EDITOR } from '../../constants'
import styles from './EditPage.module.css'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  DATA_FIELD_ERR: 'Missing required Fields'
}
const CONTENT_MODULE = {
  cta: {
    name: '',
    url: ''
  },
  description: '',
  header: '',
  icon: ''
}

const SUITE_CARD_MODULE = {
  title: '',
  subtitle: '',
  label: '',
  type: '',
  image: {},
  ctas: [],
  related_events: [],
  promotedEvents: [],
  filters: {}
}

const { REACT_APP_STAGE } = process.env

const EditPage = ({
  allGenres,
  allSuiteLevels,
  availableEventsForPromotion,
  fetchPage,
  newSuiteCardModule,
  page,
  gallery: galleryProps,
  galleryHeader,
  resetUpdatePageStatus,
  route,
  suitesAmenities,
  suitesCapacity,
  suitesEventIdeas,
  suitesEventType,
  vlpHeroAllEvents: vlpHeroAllEventsProps,
  promotedEvents,
  suitesHospitality,
  recommendedEvents,
  todaysEvent,
  tourVenues,
  upcomingEvents,
  suitesSize,
  updateMessage,
  updatePage,
  updateStatus,
  venues
}) => {
  const [isDataLoaded, setIsDataLoaded] = useState()
  const [pageId, setPageId] = useState('')
  const [pageToEdit, setPageToEdit] = useState({})
  const [vlpHeroAllEvents, setVLPHeroAllEvents] = useState([])
  const [vlpHeroPromotedEvents, setVLPHeroPromotedEvents] = useState([])
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [gallery, setGallery] = useState([])
  const [gallerySectionTitle, setGallerySectionTitle] = useState('')
  // const [isDataValid, setIsDataValid] = useState(true)

  useEffect(() => {
    if (vlpHeroAllEventsProps) {
      setVLPHeroAllEvents(vlpHeroAllEventsProps)
    }
  }, [vlpHeroAllEventsProps])

  useEffect(() => {
    if (promotedEvents) {
      setVLPHeroPromotedEvents(promotedEvents)
    }
  }, [promotedEvents])

  useEffect(() => {
    newSuiteCardModule(accessToken)
  }, [accessToken, newSuiteCardModule])

  useEffect(() => {
    const pageId = idx(route, _ => _.match.params.id)
    if (pageId) {
      setIsDataLoaded(false)
      fetchPage(pageId)
      setPageId(pageId)
    }
  }, [route, fetchPage])

  useEffect(() => {
    if (page) {
      setPageToEdit(page)
      setIsDataLoaded(true)
    }
  }, [page])

  useEffect(() => {
    if (galleryProps) {
      setGallery(galleryProps)
      setGallerySectionTitle(galleryHeader || '')
      setPageToEdit({
        ...page,
        gallery: galleryProps,
        galleryHeader
      })
      setIsDataLoaded(true)
    }
  }, [galleryProps, galleryHeader, page])

  useEffect(() => {
    if (updateStatus && updateMessage) {
      setIsDataLoaded(true)
    } else if (!updateStatus && updateMessage) {
      setIsDataLoaded(true)
      notification.error({ message: updateMessage })
      resetUpdatePageStatus()
    }
  }, [updateStatus, updateMessage, resetUpdatePageStatus])

  // const validateFields = () => {
  //   if (!pageToEdit.social_feeds.header && !pageToEdit.social_feeds.embed_url) {
  //     return false
  //   }
  //   if (!pageToEdit.upcoming_shows_section_title && !pageToEdit.recommendations_section_title) {
  //     return false
  //   }
  //   if (!pageToEdit.banner.title && !pageToEdit.banner.image.url && !pageToEdit.banner.cta.url && !pageToEdit.banner.cta.name) {
  //     return false
  //   }
  //   if (Object.entries(pageToEdit.category_pills).map((value) => { return value.some(i => (i.text && i.url && i.icon)) }).some(i => i === false)) {
  //     return false
  //   }
  //   if (Object.entries(pageToEdit.media_row).map((value) => { return value.some(i => (i.title && i.url)) }).some(i => i === false)) {
  //     return false
  //   }
  //   if (Object.entries(pageToEdit.marketing_pills).map((value) => { return value.some(i => (i.text && i.url && i.icon)) }).some(i => i === false)) {
  //     return false
  //   }
  //   if (Object.entries(pageToEdit.content_cards.cards).map((value) => { return value.some(i => (i.title && i.cta.url && i.cta.name)) }).some(i => i === false)) {
  //     return false
  //   }
  //   return true
  // }
  const handleSubmit = async () => {
    if (PAGE_TYPES_PREMIUM_EDITOR.includes(pageToEdit?.type)) {
      const { isValid, message } = validatePage(pageToEdit)

      if (!isValid) {
        notification.error({ message })
        return
      }
    }

    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }

    // if (!validateFields()) {
    //   setIsDataValid(true)
    //   notification.error({ message: NOTIFICATION_MESSAGES.DATA_FIELD_ERR })
    //   return
    // } else {
    //   setIsDataValid(true)
    // }

    setIsDataLoaded(false)
    const OBJECT_ID_REF_FIELDS = ['venue_id', 'chat_pop_up_id']
    const UNIVERSAL_TEMPLATE_ONLY_FIELDS = ['modules', 'genre']
    const sanitized = { ...pageToEdit, vlpHeroPromotedEvents }
    OBJECT_ID_REF_FIELDS.forEach(field => {
      if (sanitized[field] === '' || sanitized[field] === null) delete sanitized[field]
    })
    if (sanitized.type !== 'universal-template') {
      UNIVERSAL_TEMPLATE_ONLY_FIELDS.forEach(field => delete sanitized[field])
    }
    console.log('updatedPage ===> ', sanitized)
    updatePage(pageId, sanitized, accessToken)

    if (REACT_APP_STAGE === 'production') {
      await invalidateCFCache(MSG_CF.PROD, pageToEdit?.slug, true)
    } else {
      await invalidateCFCache(MSG_CF.NON_PROD, pageToEdit?.slug, true)
    }
  }

  const keepEditingPage = (
    <Route key="editPages" render={({ history }) => (
      <Button
        onClick={() => {
          resetUpdatePageStatus()
          history.push(`/pages/${pageId}/edit`)
        }}
        type="primary"
      >
        Keep Editing
      </Button>
    )} />
  )

  const goToListPagesButton = (
    <Route key="listPages" render={({ history }) => (
      <Button
        onClick={() => {
          resetUpdatePageStatus()
          history.push('/pages')
        }}
        type="primary"
      >
        Go to Page List
      </Button>
    )} />
  )

  const handleModalClose = () => {
    resetUpdatePageStatus()
  }

  const handlePageNameChange = event => {
    const name = event.target.value
    setPageToEdit({
      ...pageToEdit,
      name
    })
  }

  const handleSlugChange = event => {
    const slug = event.target.value
    setPageToEdit({
      ...pageToEdit,
      slug
    })
  }

  const handleGalleryChange = (gallery) => {
    setGallery(gallery)
    setPageToEdit({
      ...pageToEdit,
      gallery
    })
  }

  const addContentModule = (event) => {
    event.stopPropagation()
    const { content_modules: contentModules = [] } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...contentModules,
        CONTENT_MODULE
      ]
    })
  }

  const addSuitesCardModule = (event) => {
    event.stopPropagation()
    const { cards: suiteCards = [] } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCards,
        {
          suitesAllEvents: availableEventsForPromotion,
          related_events: [],
          promotedEvents: [],
          ...SUITE_CARD_MODULE
        }
      ]
    })
  }

  const deleteGallery = (event, dataFieldGalleryIndex) => {
    event.stopPropagation()

    const clonedGalleries = [...gallery]

    if (dataFieldGalleryIndex !== -1) {
      clonedGalleries.splice(dataFieldGalleryIndex, 1)
    }
    setGallery(clonedGalleries)
    setPageToEdit({
      ...pageToEdit,
      gallery: clonedGalleries
    })
  }

  const deleteAllGallery = (event) => {
    event.stopPropagation()

    setGallery([])
    setPageToEdit({
      ...pageToEdit,
      gallery: []
    })
  }

  const deleteAllPriceCards = (event) => {
    event.stopPropagation()
    const { tours_prices: tourPrices = {} } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...tourPrices,
        cards: []
      }
    })
  }

  const deleteAllFAQs = (event) => {
    event.stopPropagation()

    const { faqs = {} } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...faqs,
        flex_modules: []
      }
    })
  }

  const handleGalleryImageAltChange = (event, galleryIndex) => {
    const { gallery = [] } = pageToEdit
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        alt: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setPageToEdit({
      ...pageToEdit,
      gallery: updatedGallery
    })
  }

  const handleGalleryImageUrlUpdate = (imageUrl, galleryIndex) => {
    const { gallery = [] } = pageToEdit

    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        src: imageUrl
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setPageToEdit({
      ...pageToEdit,
      gallery: updatedGallery
    })
  }

  const handleGallerySubTitleChange = (event, galleryIndex) => {
    const { gallery = [] } = pageToEdit
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        subtitle: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setPageToEdit({
      ...pageToEdit,
      gallery: updatedGallery
    })
  }

  const handleGalleryTitleChange = (event, galleryIndex) => {
    const { gallery = [] } = pageToEdit
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        title: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setPageToEdit({
      ...pageToEdit,
      gallery: updatedGallery
    })
  }

  const handleGalleryMediaChange = (selectedItems, galleryIndex) => {
    const { gallery = [] } = pageToEdit
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        mediaType: selectedItems
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setPageToEdit({
      ...pageToEdit,
      gallery: updatedGallery
    })
  }

  const addGallery = (event) => {
    event.stopPropagation()
    const { gallery = [] } = pageToEdit

    gallery.push({
      title: '',
      src: '',
      alt: '',
      mediaType: '',
      subtitle: ''
    })
    setGallery(gallery)
    setPageToEdit({
      ...pageToEdit,
      gallery
    })
  }

  const handleContentModuleHeaderChange = (event, index) => {
    const header = event.target.value
    const { content_modules: contentModules = [] } = pageToEdit
    contentModules[index].header = header
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...contentModules
      ]
    })
  }

  const handleContentCardSectionHeaderChange = (event) => {
    const { content_cards: contentCards = {} } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      content_cards: {
        ...contentCards,
        header: event.target.value
      }
    })
  }

  const handleContentModuleContentChange = (paragraph, index) => {
    const { content_modules: contentModules = [] } = pageToEdit
    if (paragraph.length < 156) {
      contentModules[index].description = paragraph
      setPageToEdit({
        ...pageToEdit,
        content_modules: [
          ...contentModules
        ]
      })
    }
  }

  const handleContentModuleImageUrlUpdate = (secureImageURL, index) => {
    const { content_modules: contentModules = [] } = pageToEdit
    contentModules[index].icon = secureImageURL
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...contentModules
      ]
    })
  }

  const handleContentModuleCTAUrlChange = (event, index) => {
    const { content_modules: contentModules = [] } = pageToEdit
    contentModules[index] = {
      ...contentModules[index],
      cta: {
        ...contentModules[index].cta,
        url: event.target.value
      }
    }
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...contentModules
      ]
    })
  }

  const handleContentModuleCTANameChange = (event, index) => {
    const { content_modules: contentModules = [] } = pageToEdit
    contentModules[index] = {
      ...contentModules[index],
      cta: {
        ...contentModules[index].cta,
        name: event.target.value
      }
    }
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...contentModules
      ]
    })
  }

  const deleteContentModule = (event, index) => {
    event.stopPropagation()
    const { content_modules: contentModules = [] } = pageToEdit
    const updatedContentModules = contentModules.filter((_, i) => i !== index)
    setPageToEdit({
      ...pageToEdit,
      content_modules: [
        ...updatedContentModules
      ]
    })
  }

  const deleteSuitesCardModule = (event, index) => {
    event.stopPropagation()
    const { cards: suiteCards = [] } = pageToEdit
    const updatedCards = suiteCards.filter((_, i) => i !== index)
    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...updatedCards
      ]
    })
  }

  const handleSuiteAmenitiesChange = (amenities, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]
    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            amenities
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteCapacityChange = (capacity, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            capacity
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteEventIdeasChange = (eventideas, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            eventideas
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleAddCta = (event, index) => {
    event.stopPropagation()
    const { cards = [] } = pageToEdit
    const updatedCards = [...cards]
    updatedCards[index].ctas = [
      ...updatedCards[index].ctas,
      {
        title: '',
        href: ''
      }
    ]
    setPageToEdit({
      ...pageToEdit,
      cards: updatedCards
    })
  }

  const handleDeleteCta = (event, ctaIndex, suiteIndex) => {
    event.stopPropagation()
    const { cards = [] } = pageToEdit
    const updatedCards = [...cards]
    const clonedCTAs = updatedCards[suiteIndex].ctas

    if (ctaIndex !== -1) {
      clonedCTAs.splice(ctaIndex, 1)
    }
    setPageToEdit({
      ...pageToEdit,
      cards: updatedCards
    })
  }

  const handleSuiteEventTypeChange = (eventtype, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            eventtype
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteHospitalityChange = (hospitalitytype, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            hospitalitytype
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteSizeChange = (size, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const { filters } = suiteCard[index]

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          filters: {
            ...filters,
            size
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteLogoUpload = (secureImageURL, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const alt = getFileName(secureImageURL)

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          image: {
            alt,
            src: secureImageURL
          }
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteCardTypeChange = (type, index) => {
    const { cards: suiteCard = [] } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          type,
          suitesAllEvents: availableEventsForPromotion,
          related_events: [],
          promotedEvents: []
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteCardShortNameChange = (shortDesc, index) => {
    const { cards: suiteCard = [] } = pageToEdit
    const [filteredAllEvents] = allSuiteLevels.filter(suite => suite.type === shortDesc)
    const allEventItems = shortDesc ? filteredAllEvents?.allEvents : availableEventsForPromotion
    const allEventsFiltered = shortDesc ? filteredAllEvents?.events : []
    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          short_desc: shortDesc || '',
          suitesAllEvents: allEventItems,
          related_events: allEventsFiltered.map(({ id }) => id),
          promotedEvents: allEventsFiltered
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteSubTitleChange = (event, index) => {
    const { cards: suiteCard = [] } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          subtitle: event.target.value
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteCTAUpdate = (ctas, index) => {
    const { cards: suiteCard = [] } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          subtitle: event.target.value
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteFormStatus = (event, index) => {
    const { cards: suiteCard = [] } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          show_form: event.target.checked
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleSuiteTitleChange = (event, index) => {
    const { cards: suiteCard = [] } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      cards: [
        ...suiteCard.slice(0, index),
        {
          ...suiteCard[index],
          title: event.target.value
        },
        ...suiteCard.slice(index + 1)
      ]
    })
  }

  const handleHeroTitleChange = event => {
    const title = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        title
      }
    })
  }

  const handleHeroButtonLabelChange = event => {
    const buttonName = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        button_name: buttonName
      }
    })
  }
  const handleHeroPhoneNumberChange = event => {
    const phoneNumber = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        phone_number: phoneNumber
      }
    })
  }

  const handleHeroDescriptionChange = description => {
    const { hero } = pageToEdit

    if (description.length < 156) {
      setPageToEdit((pageToEdit) => ({
        ...pageToEdit,
        hero: {
          ...hero,
          description
        }
      }))
    }
  }
  const handleHeroSubTitleChange = event => {
    const subTitle = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        sub_title: subTitle
      }
    })
  }
  const handleHeroImageUrlUpdate = (thumbnailImageUrl, secureImageURL) => {
    const imageUrl = secureImageURL || thumbnailImageUrl
    const { hero } = pageToEdit

    const alt = getFileName(imageUrl)
    const { image } = hero
    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        image: {
          ...image,
          alt,
          src: imageUrl
        }
      }
    })
  }
  const handleHeroChatLabelChange = event => {
    const chatButton = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        chat_button: chatButton
      }
    })
  }

  const handleHeroEmailChange = event => {
    const email = event.target.value
    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        email
      }
    })
  }

  const handlePageMetaDescriptionChange = (description) => {
    const { page_meta: pageMeta } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        description
      }
    })
  }

  const handlePageMetaHeadingChange = (event) => {
    const { page_meta: pageMeta } = pageToEdit
    const heading = event.target.value

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        heading
      }
    })
  }

  const handleVenueChange = (selectedVenue) => {
    setPageToEdit({
      ...pageToEdit,
      venue_id: selectedVenue
    })
  }

  const handlePageTypeChange = selectedType => {
    setPageToEdit({
      ...pageToEdit,
      type: selectedType
    })
  }

  const handlePageMetaKeywordsChange = (event) => {
    const keywords = event.target.value
    const { page_meta: pageMeta } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        keywords
      }
    })
  }

  const handlePageMetaShowSEOChange = (event) => {
    const showSEO = event.target.checked
    const { page_meta: pageMeta } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        should_show_seo: showSEO
      }
    })
  }

  const handlePageMetaTextChange = (text) => {
    const { page_meta: pageMeta } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        text
      }
    })
  }

  const handlePageMetaTitleChange = (event) => {
    const title = event.target.value
    const { page_meta: pageMeta } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      page_meta: {
        ...pageMeta,
        title
      }
    })
  }

  const handleFormModuleIdUpdate = (event) => {
    const formstackId = event.target.value

    const { form } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        formstack_id: formstackId
      }
    })
  }

  const handleFormModuleDescriptionChange = (description) => {
    const { form } = pageToEdit

    if (description.length < 156) {
      setPageToEdit((pageToEdit) => ({
        ...pageToEdit,
        form: {
          ...form,
          description
        }
      }))
    }
  }

  const handleFormModuleHeaderChange = (header) => {
    const { form } = pageToEdit

    if (header.length < 71) {
      setPageToEdit((pageToEdit) => ({
        ...pageToEdit,
        form: {
          ...form,
          header
        }
      }))
    }
  }

  const handleFormModuleDisclaimerChange = (disclaimer) => {
    const { form } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        disclaimer
      }
    })
  }

  const handleButtonTextUpdate = (event) => {
    const submitButtonText = event.target.value
    const { form } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        submit_button_text: submitButtonText
      }
    })
  }

  const handleFormModuleTitleChange = (title) => {
    const { form } = pageToEdit
    const { success_screen: successScreen } = form
    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        success_screen: {
          ...successScreen,
          title: title
        }
      }
    })
  }

  const handleFormModuleMessageChange = (message) => {
    const { form } = pageToEdit
    const { success_screen: successScreen } = form
    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        success_screen: {
          ...successScreen,
          message
        }
      }
    })
  }

  const handleCTAHrefChange = (href, suiteIndex, ctaIndex) => {
    const { cards = [] } = pageToEdit
    const updatedCards = [...cards]
    const clonedCTAs = updatedCards[suiteIndex].ctas

    if (ctaIndex !== -1 && clonedCTAs[ctaIndex]) {
      clonedCTAs[ctaIndex].href = href
    }
    setPageToEdit({
      ...pageToEdit,
      cards: updatedCards
    })
  }

  const handleCTATitleChange = (title, suiteIndex, ctaIndex) => {
    const { cards = [] } = pageToEdit
    const updatedCards = [...cards]
    const clonedCTAs = updatedCards[suiteIndex].ctas

    if (ctaIndex !== -1 && clonedCTAs[ctaIndex]) {
      clonedCTAs[ctaIndex].title = title
    }
    setPageToEdit({
      ...pageToEdit,
      cards: updatedCards
    })
  }

  const handleFormModuleSuccessSubmitButtonTextUpdate = (event) => {
    const successScreenButtonText = event.target.value
    const { form } = pageToEdit
    const { success_screen: successScreen } = form
    setPageToEdit({
      ...pageToEdit,
      form: {
        ...form,
        success_screen: {
          ...successScreen,
          button_text: successScreenButtonText
        }
      }
    })
  }

  const handleShowCalendar = (event) => {
    event.stopPropagation()

    const { calendar } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      calendar: {
        ...calendar,
        show_calendar: event.target.checked
      }
    })
  }

  const handleCalendarTitleChange = event => {
    const title = event.target.value
    const { calendar } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      calendar: {
        ...calendar,
        title
      }
    })
  }

  const handleCalendarDescriptionChange = (description) => {
    const { calendar } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      calendar: {
        ...calendar,
        description
      }
    })
  }

  const handleOverviewDescriptionChange = (description) => {
    const { overview } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      overview: {
        ...overview,
        html_description: description
      }
    })
  }

  const handleAllEventsChange = (events, suiteIndex) => {
    const { cards: suiteCards = [] } = pageToEdit
    if (suiteCards[suiteIndex]) {
      suiteCards[suiteIndex].suitesAllEvents = [...events]
    }

    setPageToEdit({
      ...pageToEdit,
      cards: suiteCards
    })
  }

  const handleSelectedEventsChange = (selectedEvents, suiteIndex) => {
    const { cards: suiteCards = [] } = pageToEdit
    if (suiteCards[suiteIndex]) {
      suiteCards[suiteIndex].promotedEvents = [...selectedEvents]
      suiteCards[suiteIndex].related_events = selectedEvents.map(({ id }) => id)
    }

    setPageToEdit({
      ...pageToEdit,
      cards: suiteCards
    })
  }

  const handleHorizontalBanner = updatedBanner => {
    const { banner: clonedbanner } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      banner: {
        ...clonedbanner,
        ...updatedBanner
      }
    })
  }

  const addNewMediaIcon = (event) => {
    event.stopPropagation()
    const { media_row: clonedMediaRow } = pageToEdit
    const mediaIcon = {
      title: '',
      url: '',
      icon: {
        url: '',
        alt: ''
      }
    }
    setPageToEdit({
      ...pageToEdit,
      media_row: [...clonedMediaRow, mediaIcon]
    })
  }

  const addNewCategoryPill = (event) => {
    event.stopPropagation()
    const { category_pills: clonedPills } = pageToEdit
    const pillObj = {
      text: '',
      url: '',
      icon: ''
    }
    setPageToEdit({
      ...pageToEdit,
      category_pills: [...clonedPills, pillObj]
    })
  }

  const addNewMarketingPill = (event) => {
    event.stopPropagation()
    const { marketing_pills: clonedPills } = pageToEdit
    const pillObj = {
      text: '',
      url: '',
      icon: ''
    }
    setPageToEdit({
      ...pageToEdit,
      marketing_pills: [...clonedPills, pillObj]
    })
  }

  const addNewContentCardPill = (event) => {
    event.stopPropagation()
    const { content_cards: contentCards } = pageToEdit
    const cardObj = {
      title: '',
      subtitle: '',
      cta: {},
      image: {}
    }
    setPageToEdit({
      ...pageToEdit,
      content_cards: {
        ...contentCards,
        cards: [
          ...contentCards.cards,
          cardObj
        ]
      }
    })
  }

  const deleteAllCategoryPills = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      category_pills: []
    })
  }

  const deleteAllMarketingPills = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      marketing_pills: []
    })
  }

  const deleteAllMediaIcon = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      media_row: []
    })
  }

  const handleMediaRow = mediaRows => {
    setPageToEdit({
      ...pageToEdit,
      media_row: mediaRows
    })
  }

  const handleMarketingPills = marketingPills => {
    setPageToEdit({
      ...pageToEdit,
      marketing_pills: marketingPills
    })
  }

  const handleContentCard = cards => {
    setPageToEdit({
      ...pageToEdit,
      content_cards: {
        ...pageToEdit.content_cards,
        cards
      }
    })
  }

  const handleAutoplay = (event) => {
    event.stopPropagation()

    const { hero } = pageToEdit

    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        autoplay: event.target.checked
      }
    })
  }

  const handleCategoryPills = categoryPills => {
    setPageToEdit({
      ...pageToEdit,
      category_pills: categoryPills
    })
  }

  const handleFlockler = updatedFlockler => {
    const { social_feeds: flockler } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      social_feeds: {
        ...flockler,
        ...updatedFlockler
      }
    })
  }

  const handleRecommendationSectionTitle = (event) => {
    setPageToEdit({
      ...pageToEdit,
      recommendations_section_title: event.target.value
    })
  }

  const handleGallerySectionTitle = (event) => {
    setGallerySectionTitle(event.target.value)
    setPageToEdit({
      ...pageToEdit,
      galleryHeader: event.target.value
    })
  }

  const handleUpcomingShowsSectionTitle = (event) => {
    setPageToEdit({
      ...pageToEdit,
      upcoming_shows_section_title: event.target.value
    })
  }

  const handleImageUrlChange = (secureImageURL) => {
    const { hero } = pageToEdit
    const alt = getFileName(secureImageURL)
    const { image } = hero
    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        image: {
          ...image,
          alt,
          src: secureImageURL
        }
      }
    })
  }

  const addNewLink = (event) => {
    event.stopPropagation()
    let { anchor_links: clonedLinks } = pageToEdit
    const linkObj = {
      label: '',
      link: ''
    }
    if (!clonedLinks) {
      clonedLinks = []
    }
    setPageToEdit({
      ...pageToEdit,
      anchor_links: [...clonedLinks, linkObj]
    })
  }

  const deleteAllLink = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      anchor_links: []
    })
  }

  const setAnchorLinks = links => {
    setPageToEdit({
      ...pageToEdit,
      anchor_links: [
        ...links
      ]
    })
  }

  const handleImageChange = (imgObj) => {
    const { hero } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      hero: {
        ...hero,
        image: imgObj
      }
    })
  }

  const addNewMarketingModule = (event) => {
    event.stopPropagation()
    const { marketing_modules: clonedPills } = pageToEdit
    const pillObj = {
      text: '',
      url: '',
      icon: ''
    }
    setPageToEdit({
      ...pageToEdit,
      marketing_modules: [...clonedPills, pillObj]
    })
  }

  const addNewFAQ = (event) => {
    event.stopPropagation()
    const { faqs: faqsCards } = pageToEdit
    const cardObj = {
      title: '',
      subtitle: '',
      cta: {},
      images: []
    }
    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...faqsCards,
        flex_modules: [
          ...faqsCards?.flex_modules,
          cardObj
        ]
      }
    })
  }

  const addNewFAQImage = (card, rowIndex) => {
    const { faqs: faqsCards } = pageToEdit
    const cardImgObj = {
      url: '',
      alt: '',
      href: ''
    }
    faqsCards?.flex_modules?.[rowIndex]?.images?.push(cardImgObj)

    console.log(faqsCards)
    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...faqsCards
      }
    })
  }

  const deleteAllFAQsImages = (rowIndex) => {
    const { faqs: faqsCards } = pageToEdit
    const { flex_modules: flexModules } = faqsCards

    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...faqsCards,
        flex_modules: [
          ...flexModules.slice(0, rowIndex),
          {
            ...flexModules[rowIndex],
            images: []
          },
          ...flexModules.slice(rowIndex + 1)
        ]
      }
    })
  }

  const deleteAllMarketingModules = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      marketing_modules: []
    })
  }

  const handleMarketingModules = marketingModules => {
    setPageToEdit({
      ...pageToEdit,
      marketing_modules: marketingModules
    })
  }

  const handlePriceCardSectionHeaderChange = (event) => {
    const { tours_prices: tourPrices = {} } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...tourPrices,
        header: event.target.value
      }
    })
  }

  const handleOverviewSectionHeaderChange = (event) => {
    const { overview = {} } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      overview: {
        ...overview,
        header: event.target.value
      }
    })
  }

  const handleFAQsSectionHeaderChange = (event) => {
    const { faqs: faqsCards } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...faqsCards,
        header: event.target.value
      }
    })
  }

  const deleteAllPriceCard = (event) => {
    event.stopPropagation()
    setPageToEdit({
      ...pageToEdit,
      tours_prices: []
    })
  }
  const addPriceCard = (event) => {
    event.stopPropagation()
    const { tours_prices: priceCards } = pageToEdit
    const cardObj = {
      title: '',
      subtitle: '',
      cta: {},
      image: {}
    }
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...priceCards,
        cards: [
          ...priceCards.cards,
          cardObj
        ]
      }
    })
  }

  const handlePriceCardDisclaimerChange = (disclaimer) => {
    const { tours_prices: tourPrices = {} } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...tourPrices,
        disclaimer
      }
    })
  }

  const handleTourPlanDescriptionChange = (description) => {
    const { tours_prices: tourPrices = {} } = pageToEdit
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...tourPrices,
        html_description: description
      }
    })
  }

  const handlePriceCard = cards => {
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...pageToEdit.tours_prices,
        cards
      }
    })
  }

  const handleFAQs = cards => {
    setPageToEdit({
      ...pageToEdit,
      faqs: {
        ...pageToEdit.faqs,
        flex_modules: cards
      }
    })
  }

  const addNewPriceCard = (event) => {
    event.stopPropagation()
    const { tours_prices: tourPrices } = pageToEdit
    const cardObj = {
      title: '',
      subtitle: '',
      cta: {},
      image: {}
    }
    setPageToEdit({
      ...pageToEdit,
      tours_prices: {
        ...tourPrices,
        cards: [
          ...tourPrices.cards,
          cardObj
        ]
      }
    })
  }

  const handleChatbotStatus = status => {
    setPageToEdit({
      ...pageToEdit,
      show_chatbot: status
    })
  }

  const handleChatPopUpIdChange = event => {
    setPageToEdit({
      ...pageToEdit,
      chat_pop_up_id: event.target.value
    })
  }

  const chatPopUpIdInput = (
    <Input
      disabled={!pageToEdit?.show_chatbot}
      onChange={handleChatPopUpIdChange}
      placeholder="Satisfi Modal ID"
      style={{ width: 240 }}
      value={pageToEdit?.chat_pop_up_id ?? ''}
    />
  )

  const handleAddUniversalModule = moduleType => {
    setPageToEdit({
      ...pageToEdit,
      modules: [...(pageToEdit.modules || []), createEmptyUniversalModule(moduleType)]
    })
  }

  const handleDeleteUniversalModule = (event, index) => {
    event.stopPropagation()
    const modules = [...(pageToEdit.modules || [])]
    modules.splice(index, 1)
    setPageToEdit({
      ...pageToEdit,
      modules
    })
  }

  const handleUniversalModuleUpdate = (index, updated) => {
    const modules = [...(pageToEdit.modules || [])]
    modules[index] = updated
    setPageToEdit({
      ...pageToEdit,
      modules
    })
  }

  const handleUniversalGenreChange = value => {
    setPageToEdit({
      ...pageToEdit,
      genre: value || ''
    })
  }

  const handleUniversalModuleReorder = (index, direction) => {
    const modules = [...(pageToEdit.modules || [])]
    const swapIndex = direction === 'up' ? index - 1 : index + 1
    if (swapIndex < 0 || swapIndex >= modules.length) return
    ;[modules[index], modules[swapIndex]] = [modules[swapIndex], modules[index]]
    setPageToEdit({ ...pageToEdit, modules })
  }

  const isUniversalTemplate = pageToEdit?.type === 'universal-template'
  const universalTemplateReadyReasons = isUniversalTemplate ? [
    ...(!pageToEdit?.name?.trim() ? ['Name is required'] : []),
    ...(!(/^\/sweepstakes\/[a-z0-9][a-z0-9-]*$/.test(pageToEdit?.slug || '')) ? ['Slug must be /sweepstakes/<valid-slug>'] : []),
    ...(!(pageToEdit?.genre?.trim()) ? ['Genre is required'] : []),
    ...((pageToEdit?.modules || []).length === 0 ? ['At least one module is required'] : [])
  ] : []
  const isUniversalTemplateReady = universalTemplateReadyReasons.length === 0

  const updatePageButton = (
    <Tooltip title={universalTemplateReadyReasons.length ? universalTemplateReadyReasons.join(' · ') : undefined}>
      <span>
        <Button className={styles.updateActionButton} disabled={isUniversalTemplate && !isUniversalTemplateReady} onClick={handleSubmit} type='primary'>
          Update
        </Button>
      </span>
    </Tooltip>
  )
  const toggleSwitch = <Switch checked={pageToEdit?.show_chatbot ?? false} checkedChildren="Show Satisfi" defaultChecked onChange={handleChatbotStatus} unCheckedChildren="Hide Satisfi" />

  console.log('handleSelectedEventsChange ===> ', vlpHeroAllEvents, vlpHeroPromotedEvents)
  return (
    <Layout className={styles['edit-page-container']}>
      <PageHeader className={styles.headline} extra={[toggleSwitch, updatePageButton]} title='Update Page' />
      <Layout.Content>
        <div>
          <PageBasicInfo
            addContentModule={addContentModule}
            addGallery={addGallery}
            addNewCategoryPill={addNewCategoryPill}
            addNewContentCardPill={addNewContentCardPill}
            addNewFAQ={addNewFAQ}
            addNewFAQImage={addNewFAQImage}
            addNewLink={addNewLink}
            addNewMarketingModule={addNewMarketingModule}
            addNewMarketingPill={addNewMarketingPill}
            addNewMediaIcon={addNewMediaIcon}
            addNewPriceCard={addNewPriceCard}
            addPriceCard={addPriceCard}
            addSuitesCardModule={addSuitesCardModule}
            allGenres={allGenres}
            allSuiteLevels={allSuiteLevels}
            deleteAllCategoryPills={deleteAllCategoryPills}
            deleteAllFAQs={deleteAllFAQs}
            deleteAllFAQsImages={deleteAllFAQsImages}
            deleteAllGallery={deleteAllGallery}
            deleteAllLink={deleteAllLink}
            deleteAllMarketingModules={deleteAllMarketingModules}
            deleteAllMarketingPills={deleteAllMarketingPills}
            deleteAllMediaIcon={deleteAllMediaIcon}
            deleteAllPriceCard={deleteAllPriceCard}
            deleteAllPriceCards={deleteAllPriceCards}
            deleteContentModule={deleteContentModule}
            deleteGallery={deleteGallery}
            deleteSuitesCardModule={deleteSuitesCardModule}
            galleries={gallery}
            gallery_header={gallerySectionTitle || ''}
            handleAddCta={handleAddCta}
            handleAddUniversalModule={handleAddUniversalModule}
            handleAllEventsChange={handleAllEventsChange}
            handleAutoplay={handleAutoplay}
            handleButtonTextUpdate={handleButtonTextUpdate}
            handleCTAHrefChange={handleCTAHrefChange}
            handleCTATitleChange={handleCTATitleChange}
            handleCalendarDescriptionChange={handleCalendarDescriptionChange}
            handleCalendarTitleChange={handleCalendarTitleChange}
            handleCategoryPills={handleCategoryPills}
            handleContentCard={handleContentCard}
            handleContentCardSectionHeaderChange={handleContentCardSectionHeaderChange}
            handleContentModuleCTANameChange={handleContentModuleCTANameChange}
            handleContentModuleCTAUrlChange={handleContentModuleCTAUrlChange}
            handleContentModuleContentChange={handleContentModuleContentChange}
            handleContentModuleHeaderChange={handleContentModuleHeaderChange}
            handleContentModuleImageUrlUpdate={handleContentModuleImageUrlUpdate}
            handleDeleteCta={handleDeleteCta}
            handleDeleteUniversalModule={handleDeleteUniversalModule}
            handleFAQs={handleFAQs}
            handleFAQsSectionHeaderChange={handleFAQsSectionHeaderChange}
            handleFlockler={handleFlockler}
            handleFormModuleDescriptionChange={handleFormModuleDescriptionChange}
            handleFormModuleDisclaimerChange={handleFormModuleDisclaimerChange}
            handleFormModuleHeaderChange={handleFormModuleHeaderChange}
            handleFormModuleIdUpdate={handleFormModuleIdUpdate}
            handleFormModuleMessageChange={handleFormModuleMessageChange}
            handleFormModuleSuccessSubmitButtonTextUpdate={handleFormModuleSuccessSubmitButtonTextUpdate}
            handleFormModuleTitleChange={handleFormModuleTitleChange}
            handleGalleryChange={handleGalleryChange}
            handleGalleryImageAltChange={handleGalleryImageAltChange}
            handleGalleryImageUrlUpdate={handleGalleryImageUrlUpdate}
            handleGalleryMediaChange={handleGalleryMediaChange}
            handleGallerySectionTitle={handleGallerySectionTitle}
            handleGallerySubTitleChange={handleGallerySubTitleChange}
            handleGalleryTitleChange={handleGalleryTitleChange}
            handleHeroButtonLabelChange={handleHeroButtonLabelChange}
            handleHeroChatLabelChange={handleHeroChatLabelChange}
            handleHeroDescriptionChange={handleHeroDescriptionChange}
            handleHeroEmailChange={handleHeroEmailChange}
            handleHeroImageUrlUpdate={handleHeroImageUrlUpdate}
            handleHeroPhoneNumberChange={handleHeroPhoneNumberChange}
            handleHeroSubTitleChange={handleHeroSubTitleChange}
            handleHeroTitleChange={handleHeroTitleChange}
            handleHorizontalBanner={handleHorizontalBanner}
            handleImageChange={handleImageChange}
            handleImageUrlChange={handleImageUrlChange}
            handleMarketingPills={handleMarketingPills}
            handleMediaRow={handleMediaRow}
            handleOverviewDescriptionChange={handleOverviewDescriptionChange}
            handleOverviewSectionHeaderChange={handleOverviewSectionHeaderChange}
            handlePageMetaDescriptionChange={handlePageMetaDescriptionChange}
            handlePageMetaHeadingChange={handlePageMetaHeadingChange}
            handlePageMetaKeywordsChange={handlePageMetaKeywordsChange}
            handlePageMetaShowSEOChange={handlePageMetaShowSEOChange}
            handlePageMetaTextChange={handlePageMetaTextChange}
            handlePageMetaTitleChange={handlePageMetaTitleChange}
            handlePageNameChange={handlePageNameChange}
            handlePageTypeChange={handlePageTypeChange}
            handlePriceCard={handlePriceCard}
            handlePriceCardDisclaimerChange={handlePriceCardDisclaimerChange}
            handlePriceCardSectionHeaderChange={handlePriceCardSectionHeaderChange}
            handleRecommendationSectionTitle={handleRecommendationSectionTitle}
            handleSelectedEventsChange={handleSelectedEventsChange}
            handleShowCalendar={handleShowCalendar}
            handleSlugChange={handleSlugChange}
            handleSuiteAmenitiesChange={handleSuiteAmenitiesChange}
            handleSuiteCTAUpdate={handleSuiteCTAUpdate}
            handleSuiteCapacityChange={handleSuiteCapacityChange}
            handleSuiteCardShortNameChange={handleSuiteCardShortNameChange}
            handleSuiteCardTypeChange={handleSuiteCardTypeChange}
            handleSuiteEventIdeasChange={handleSuiteEventIdeasChange}
            handleSuiteEventTypeChange={handleSuiteEventTypeChange}
            handleSuiteFormStatus={handleSuiteFormStatus}
            handleSuiteHospitalityChange={handleSuiteHospitalityChange}
            handleSuiteLogoUpload={handleSuiteLogoUpload}
            handleSuiteSizeChange={handleSuiteSizeChange}
            handleSuiteSubTitleChange={handleSuiteSubTitleChange}
            handleSuiteTitleChange={handleSuiteTitleChange}
            handleTourPlanDescriptionChange={handleTourPlanDescriptionChange}
            handleUniversalGenreChange={handleUniversalGenreChange}
            handleUniversalModuleReorder={handleUniversalModuleReorder}
            handleUniversalModuleUpdate={handleUniversalModuleUpdate}
            handleUpcomingShowsSectionTitle={handleUpcomingShowsSectionTitle}
            handleVenueChange={handleVenueChange}
            mode='edit'
            page={pageToEdit}
            pageTypes={PAGE_TYPES}
            recommendedEvents={recommendedEvents}
            selectedType={pageToEdit?.type}
            setAnchorLinks={setAnchorLinks}
            setGallery={setGallery}
            setMarketingModules={handleMarketingModules}
            setVLPHeroAllEvents={setVLPHeroAllEvents}
            setVLPHeroPromotedEvents={setVLPHeroPromotedEvents}
            suitesAmenities={suitesAmenities}
            suitesCapacity={suitesCapacity}
            suitesEventIdeas={suitesEventIdeas}
            suitesEventType={suitesEventType}
            suitesHospitality={suitesHospitality}
            suitesSize={suitesSize}
            todaysEvent={todaysEvent}
            tourVenues={tourVenues}
            upcomingEvents={upcomingEvents}
            venues={venues}
            vlpHeroAllEvents={vlpHeroAllEvents}
            vlpHeroPromotedEvents={vlpHeroPromotedEvents}
          />
        </div>
        <div style={{ padding: '16px 24px' }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>Satisfi Chatbot Modal ID</div>
          {chatPopUpIdInput}
        </div>
        <Spinner isLoading={!isDataLoaded}/>
        {
          updateStatus &&
          <ResultModal
            actions={[
              goToListPagesButton,
              keepEditingPage
            ]}
            handleCancel={handleModalClose}
            status="success"
            title={updateMessage}
          />
        }
      </Layout.Content>
    </Layout>
  )
}

EditPage.propTypes = {
  allGenres: PropTypes.array,
  allSuiteLevels: PropTypes.array,
  availableEventsForPromotion: PropTypes.array,
  fetchPage: PropTypes.func,
  gallery: PropTypes.array,
  galleryHeader: PropTypes.string,
  newSuiteCardModule: PropTypes.func,
  page: PropTypes.object,
  promotedEvents: PropTypes.array,
  recommendedEvents: PropTypes.array,
  resetUpdatePageStatus: PropTypes.func,
  route: PropTypes.object.isRequired,
  suitesAmenities: PropTypes.array.isRequired,
  suitesCapacity: PropTypes.array.isRequired,
  suitesEventIdeas: PropTypes.array.isRequired,
  suitesEventType: PropTypes.array.isRequired,
  suitesHospitality: PropTypes.array.isRequired,
  suitesSize: PropTypes.array.isRequired,
  todaysEvent: PropTypes.array,
  tourVenues: PropTypes.array,
  upcomingEvents: PropTypes.array,
  updateMessage: PropTypes.string,
  updatePage: PropTypes.func,
  updateStatus: PropTypes.bool,
  venues: PropTypes.array.isRequired,
  vlpHeroAllEvents: PropTypes.array
}

const mapStateToProps = ({ pages, suiteCards }) => ({
  page: pages.page,
  gallery: pages.gallery,
  galleryHeader: pages.gallery_header,
  updateStatus: pages.success,
  updateMessage: pages.message,
  recommendedEvents: pages.recommendedEvents,
  vlpHeroAllEvents: pages.vlpHeroAllEvents,
  promotedEvents: pages.promotedEvents,
  todaysEvent: pages.todaysEvent,
  upcomingEvents: pages.upcomingEvents,
  suitesAmenities: suiteCards.suitesAmenities,
  suitesCapacity: suiteCards.suitesCapacity,
  suitesEventIdeas: suiteCards.suitesEventIdeas,
  suitesEventType: suiteCards.suitesEventType,
  suitesHospitality: suiteCards.suitesHospitality,
  suitesSize: suiteCards.suitesSize,
  availableEventsForPromotion: suiteCards.allEvents,
  allSuiteLevels: suiteCards.allSuiteLevels,
  tourVenues: pages.tourVenues,
  venues: pages.allVenues,
  allGenres: pages.allGenres
})

const mapDispatchToProps = {
  fetchPage: fetchPageById,
  newSuiteCardModule,
  resetUpdatePageStatus,
  updatePage
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPage)
